<template>

<div>
<el-row>
  <el-col :span="24">
    <div class="grid-content bg-purple-light">
        <div class="searchTitle2">
       <b> RFID 발행 </b>
      </div>

      <!-- 조회 조건 영역 -->
      <div class="searchBody">
        <!-- 조회 조건 영역 -->
        <div class="searchBody">
            <div class="searchBody_year" style="font-size: 15px !important;">
            진행상태
          </div>
          <div style="margin-left: 10px">
            <el-select v-model="statusOption"  >
              <el-option
                  v-for="item in statusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
          <div class="searchBody_year" style="font-size: 15px !important;">
          확정 일자
          </div>
          <div style="margin-left: 10px">
          <el-date-picker
            v-model="confirmStartDateOption"
            type="date"
            placeholder="Pick a day"
            value-format="yyyy-MM-dd"
            class="date-input"
            >
          </el-date-picker>
          ~
          <el-date-picker
            v-model="confirmEndDateOption"
            type="date"
            placeholder="Pick a day"
            value-format="yyyy-MM-dd"
            class="date-input"
            >
          </el-date-picker>
          </div>


          <div class="searchBody_brand" style="margin-left: 10px !important;">
              <el-button
                      :loading="loading"
                      type="primary"
                      @click="search"
              >Search</el-button>
          </div>
      </div>
      </div>



      <!-- 조회 조건 영역 -->





  </el-col>

</el-row>



    <el-row>
        <el-col :span="50">
            <div class="grid-content bg-purple-light" style="height: 100% !important;" >
                <el-table
                        v-loading="loading"
                        ref="multipleTable"
                        :data="tableData"
                        style="width: 100%; height:100%"
                        border
                        @selection-change="handleSelectionChange"
                        :row-class-name="tableRowClassName"
                        size="small"
                        :row-style="{ height: 0 + 'px' }"
                        :cell-style="{ padding: 0 + 'px' }"
                        :header-cell-style="{
                          background: '#2F384E',
                          color: '#fff',
                          height: '10px',
                          padding: '0px',
                        }"
                >
    <el-table-column
      type="selection"
      width="35"
      >
    </el-table-column>

    <!-- data 시작 -->
    <!-- <el-table-column
      label="Date"
      width="120">
      <template slot-scope="scope">{{ scope.row.date }}</template>
    </el-table-column> -->

    <el-table-column
      property="seq"
      label="seq"
      width="50">
    </el-table-column>

    <!-- <el-table-column
      property="rfid_get_order_seq"
      label="get_order_seq"
      width="100">
    </el-table-column> -->

    <el-table-column
      property="rfid_order_seq"
      label="발주번호"
      width="100">
    </el-table-column>


   <el-table-column
       label="상태"
       width="80"
       property="statusLavel"
   >
   </el-table-column>


    <el-table-column
      property="confirm_date"
      label="발주 일자"
      width="190">
    </el-table-column>

   <el-table-column
      property="dept_name"
      label="업체명"
      width="220">
    </el-table-column>



   <el-table-column
      
      label="RFID 발주수량"
      width="100"
      color="#FFFFFF"
      property="rfid_order_amount"
      >
<!--       <template slot-scope="scope">-->
<!--          <div style="color:#2C5AA0"> <b>{{scope.row.rfid_order_amount}} </b></div>-->
<!--       </template>-->
    </el-table-column>



   <el-table-column
       label="추가인증코드"
       width="200"
       property="add_auth_code"
   >

   </el-table-column>




 </el-table>




 <el-row>
  <el-col :span="24"><div class="pagination"  >

<el-pagination
  small
  
  layout="prev, pager, next"
      :total="totalSize"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-size="pageSize"
  >
</el-pagination>

<!--  <el-button-->
<!--    :loading="loading"-->
<!--    type="primary"-->
<!--    @click="save(1)"-->
<!--  >발행 접수</el-button>-->


    <el-button
    :loading="loading"
    type="primary"
    @click="excelDownFunc"
  > 엑셀 다운로드 (시작)</el-button>


    <el-button
        :loading="loading"
        type="primary"
        @click="remove"
    > 삭제 </el-button>

  </div>
      <!-- div class="grid-content bg-purple-light"> -->
  </el-col>
 </el-row>



<el-dialog
  title="발행결과 파일 업로드"
  :visible.sync="dialogVisible"
  width="30%"
  v-loading="loading"
  :before-close="Confirm" 
  >
    <span class="text-reader">
      <form ref="form">

      <input type="file" @change="filesChange" class="FileUpload__default" accept=".csv" multiple  />
      </form>
    </span>

    <span slot="footer" class="dialog-footer">
    <!-- <el-button @click="dialogVisible = false">Cancel</el-button> -->
    <el-button type="primary" @click="Confirm">Confirm</el-button>
  </span>


</el-dialog>


</div>
 </el-col>
 </el-row>

</div>
</template>


<script>
import Axios from 'axios'; 
// import XLSX from 'xlsx'

  export default {
    created() {
      this.$store.commit("dayBefore",0);
      this.confirmEndDateOption = this.$store.state.dateOption; // 조회조건에서 현재 날짜 
      this.$store.commit("dayBefore",7);
      this.confirmStartDateOption = this.$store.state.dateOption; // 조회조건이서 현재보다 -7 일
      if (this.$store.state.userId != 'admin') {
        // this.deptSeqOption = this.$store.state.deptSeq;
        // this.deptNameOption = this.$store.state.deptName;
      }

      // console.log()
      // 페이지로딩시 조회
      this.search();
    },//created    
    data() {
      return {
        // table 관련 data 
        tableData: [],
        totalData: [],
        multipleSelection: [],
        saveData:[],
        saveData2:[],
        currentPage: 1,
        pageSize:10,
        totalSize:0,

        // loading 변수 true 이면 loging 화면 보여줌
        loading:false,

        // 조회조건 관련 변수
        brandOptions: [{
          value: 'CW',
          label: 'CW'
        }, {
          value: 'KO',
          label: 'KO'
        }, {
          value: 'CM',
          label: 'CM'
        }, {
          value: 'KS',
          label: 'KS'
        },],

        statusOptions: [{
          value: '1',
          label: '확정'
        },
        //   {
        //   value: '2',
        //   label: '접수'
        // },
          {
          value: '3',
          label: '발행시작'
        }, {
          value: '4',
          label: '발행완료'
        },],
        brandOption: '',
        styleOption :'',
        deptNameOption:'',
        deptSeqOption:0,
        confirmStartDateOption:'',
        confirmEndDateOption:'',
        statusOption:'1',
        status:'',     
        fileList: [],
        text :[],
        dialogVisible: false,
        statusLavel:'',
      } // return 
    },// data

    methods: {


      formatDownloadDateTime(date = new Date()) {
        const pad = value => String(value).padStart(2, '0');
        return `${date.getFullYear()}${pad(date.getMonth() + 1)}${pad(date.getDate())}_${pad(date.getHours())}${pad(date.getMinutes())}`;
      },

      sanitizeFileName(value) {
        return (value || '업체명없음').toString().trim().replace(/[\\/:*?"<>|]/g, '_').replace(/\s+/g, '_');
      },



      async search(){
        this.loading = true;

        // default data 
        let url = this.$url + '/rfidOrder/list';
        var reqJson = new Object();
        reqJson.brand = this.brandOption;
        reqJson.style = this.styleOption;
        reqJson.dept_name = this.deptNameOption;
        // reqJson.dept_seq = this.deptSeqOption;
        reqJson.confirm_start_date = this.confirmStartDateOption;
        reqJson.confirm_end_date = this.confirmEndDateOption;
      
        if (this.statusOption == null || this.statusOption == '')
        {
          reqJson.status = '1';
        }else {
          reqJson.status = this.statusOption;
        }

        await Axios.post(url, reqJson , this.$store.state.config ).then(res => {  
          var resDataJson = res.data.rfidOrderDTO;
          this.totalData=[];

          if (res.data.resultCode){

            if (this.statusOption=='1')
            {
              this.statusLavel = "확정"
            }else  if (this.statusOption=='3')
            {
              this.statusLavel = "발행시작"
            }else  if (this.statusOption=='4')
            {
              this.statusLavel = "발행완료"
            }


            for(var resData in resDataJson){
              this.totalData.push({ 
                  seq : resData
                , rfid_order_seq: resDataJson[resData]['rfid_order_seq']
                , style: resDataJson[resData]['style'] 
                , color: resDataJson[resData]['color']
                , size: resDataJson[resData]['size']
                , order_degree: resDataJson[resData]['order_degree'] 
                , brand: resDataJson[resData]['brand']
                , product_amount: resDataJson[resData]['product_amount']
                , rfid_order_amount: resDataJson[resData]['rfid_order_amount']
                , publish_amount : resDataJson[resData]['publish_amount']
                , publish_date : resDataJson[resData]['publish_date']
                , rfid_take_amount: resDataJson[resData]['rfid_take_amount']
                , confirm_date: resDataJson[resData]['confirm_date']
                , dept_name: resDataJson[resData]['dept_name']
                , take_date: resDataJson[resData]['take_date']
                , address1: resDataJson[resData]['address1']
                , address2: resDataJson[resData]['address2']
                , rfid_get_order_seq: resDataJson[resData]['rfid_get_order_seq']
                , publish_start_number: resDataJson[resData]['publish_start_number']
                , publish_end_number: resDataJson[resData]['publish_end_number']
                , status: resDataJson[resData]['status']
                , rfid_order_confirm_amount : resDataJson[resData]['rfid_order_confirm_amount']
                , add_auth_code : resDataJson[resData]['add_auth_code']
                  , statusLavel : this.statusLavel
              });
            }
            // 전체 데이터 사이즈 
            this.totalSize = this.totalData.length;
            // 보여주는 부분만 slice 
            this.tableData = this.totalData.slice(0, this.pageSize);
            this.currentPage = 1;
            this.loading = false;
            this.status = reqJson.status;
            this.$message.success(this.$store.state.searchSuccess);
          }else{
            this.$message.error(this.$store.state.dataNotFound);
            this.currentPage = 1;
            this.loading = false;
          }
        }) // await Axios.post
        .catch(error => {
          console.log(error.response)
          this.$message.error(this.$store.state.serverErrorMessage);
          this.currentPage = 1;
          this.loading = false;
        }); // await Axios.post
      },//search

      toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      }, //toggleSelection

      // check box click event 
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      tableRowClassName({row, rowIndex}) {
        if (rowIndex === 1) {
        //  return 'warning-row';
        } else if (rowIndex === 3) {
        //  return 'success-row';
        }
         console.log(row);
        return '';
      },    
      handleSizeChange(val) {
        console.log(`${val} items per page`);
      },

      // pagging event 
      handleCurrentChange(val) {
        this.tableData = this.totalData.slice( (this.pageSize * val - this.pageSize )   , this.pageSize * val);
      },

       save(value){

        let url = "";

        if (this.multipleSelection.length <= 0)
        {
          this.$message.error("데이터를 선택하세요 ");
          return ;
        }

        // if (value == 1) // 발행접수
        // {
        //   if (this.status != '1') //status 가 1이어야만저장 가능
        //   {
        //     this.$message.error("확정상테의 데이터만 발행접수가 가능합니다. ");
        //     return ;
        //   }
        //   url = this.$url + '/rfidOrder/rfidReceipt';
        // }else

         if (value == 2){
          // if (this.status != '1')
          // {
          //   this.$message.error("발행접수 상태의 데이터만 발행 시작 가능합니다 . ");
          //   return ;
          // }
          url = this.$url + '/rfidOrder/rfidPublishStart';
         }
        //else if (value == 3){
        //    if (this.status != '3')
        //   {
        //     this.$message.error("발행시작 상태의 데이터만 완료 가능합니다 . ");
        //     return ;
        //   }
        //   url = this.$url + '/rfidOrder/rfidPublishComplete';
        // }

         for(var resData in this.multipleSelection){
           this.multipleSelection[resData]['reg_user_id'] = this.$store.state.userId
           this.multipleSelection[resData]['upd_user_id'] = this.$store.state.userId

           this.multipleSelection[resData]['rfid_order_amount'] =  this.multipleSelection[resData]['rfid_order_amount'] *=1;
           this.multipleSelection[resData]['publish_amount'] =  this.multipleSelection[resData]['publish_amount'] *=1;
           this.multipleSelection[resData]['publish_start_number'] =  this.multipleSelection[resData]['publish_start_number'] *=1;
           this.multipleSelection[resData]['publish_end_number'] =  this.multipleSelection[resData]['publish_end_number'] *=1;


         }


        this.loading = true;
        Axios.post(url, this.multipleSelection , this.$store.state.config  ).then(res => {
         
          //console.log(res);
          let saveCount = res.data;
          this.loading = false;
          this.$message.success(saveCount +'건 ' + this.$store.state.saveSuccess);
          this.search();

        }).catch(error => {
          console.log(error.response)
          this.$message.error(this.$store.state.serverErrorMessage);
          this.currentPage = 1;
          this.loading = false;
        }); // await Axios.post
      }, // save
      //
      // async excelDownFunc(){
      //   if (this.status != '1')
      //   {
      //     this.$message.error("확정 상태의 데이터만 발행 시작 가능합니다 . ");
      //     return ;
      //   }
      //
      //   if(this.multipleSelection==null || this.multipleSelection.length == 0 ){
      //     this.$message.error(this.$store.state.noDataSelect);
      //     return ;
      //   }
      //
      //   this.loading = true;
      //
      //   for (var i in this.multipleSelection)
      //   {
      //
      //
      //     let url = this.$url + '/rfidInfo/publish';
      //     var reqJson = new Object();
      //     reqJson.rfid_order_seq = this.multipleSelection[i]['rfid_order_seq']
      //
      //     await Axios.post(url, reqJson , this.$store.state.config ).then(res => {
      //           var resDataJson = res.data.rfidInfoDTO;
      //
      //       var excepData = [];
      //
      //       for (var i in resDataJson) {
      //         excepData.push({
      //            qr_code : resDataJson[i]['qr_code']
      //           ,일련번호 : resDataJson[i]['auth_key']
      //         });
      //       }
      //
      //       this.loading = true;
      //       var dataWS = XLSX.utils.json_to_sheet(excepData);
      //       var wb = XLSX.utils.book_new();
      //       // workbook에 워크시트 추가
      //       // 시트명은 'nameData'
      //       XLSX.utils.book_append_sheet(wb, dataWS, 'QR_CODE');
      //       // 엑셀 파일을 내보낸다.
      //       this.$store.commit("dayBefore",0); // 오늘날짜
      //       XLSX.writeFile(wb, "QR_CODE발행"+'.csv');
      //       this.loading = false;
      //
      //
      //
      //     }) // await Axios.post
      //         .catch(error => {
      //           console.log(error.response)
      //           this.$message.error(this.$store.state.serverErrorMessage);
      //           this.currentPage = 1;
      //           this.loading = false;
      //      }); // await Axios.post
      //
      //   } // for
      //
      // }, //excelDownFunc


        async excelDownFunc() {
            if (this.status != '1') {
                this.$message.error("확정 상태만 가능합니다.");
                return;
            }

            if (!this.multipleSelection || this.multipleSelection.length === 0) {
                this.$message.error(this.$store.state.noDataSelect);
                return;
            }

            this.loading = true;

              for (var i in this.multipleSelection) {

                  try {
                      // 100만 건은 Axios로 받지 말고 직접 링크로 요청하는 것이 메모리에 안전합니다.
                      // 만약 보안 토큰이 필요하다면 Blob 방식을 사용하세요.
                      const url = this.$url + '/rfidInfo/downloadCsv';
                      const response = await Axios.post(url, {
                          rfid_order_seq: this.multipleSelection[i].rfid_order_seq
                      }, {
                          responseType: 'blob' // 중요: 데이터를 바이너리(파일)로 받음
                      });

                      const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8' });
                      const link = document.createElement('a');
                      const objectUrl = window.URL.createObjectURL(blob);
                      link.href = objectUrl;
                      const companyName = this.sanitizeFileName(this.multipleSelection[i].dept_name);
                      const downloadedAt = this.formatDownloadDateTime();
                      link.setAttribute('download', `${companyName}_${downloadedAt}.csv`);
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);
                      window.URL.revokeObjectURL(objectUrl);

                  } catch (error) {

                      console.error(error);
                      this.$message.error("파일 다운로드 중 오류가 발생했습니다.");
                      this.loading = false;
                  }
              }
            this.loading = false;
        },


        //
        // async excelDownFunc() {
        //     if (this.status != '1') {
        //         this.$message.error("확정 상태의 데이터만 발행 시작 가능합니다.");
        //         return;
        //     }
        //     if (!this.multipleSelection || this.multipleSelection.length == 0) {
        //         this.$message.error(this.$store.state.noDataSelect);
        //         return;
        //     }
        //
        //     this.loading = true;
        //     let allExcepData = []; // 모든 데이터를 담을 하나의 그릇
        //
        //     try {
        //         for (let item of this.multipleSelection) {
        //             let url = this.$url + '/rfidInfo/publish';
        //             let reqJson = { rfid_order_seq: item.rfid_order_seq };
        //             reqJson = { rfid_order_seq: item.rfid_order_seq };
        //
        //             // 1. 순차적으로 데이터를 가져와서 allExcepData에 합침
        //             const res = await Axios.post(url, reqJson, this.$store.state.config);
        //             const resDataJson = res.data.rfidInfoDTO;
        //
        //             for (let row of resDataJson) {
        //                 allExcepData.push({
        //                     qr_code: row.qr_code,
        //                     auth_key: row.auth_key
        //                 });
        //             }
        //         }
        //
        //         // 2. 루프가 끝난 후 "단 한 번" 파일 생성
        //         if (allExcepData.length > 0) {
        //             // 데이터가 너무 많으므로 XLSX 대신 가벼운 CSV 문자열로 직접 생성 추천
        //             let csvContent = "\uFEFFqr_code,일련번호\n"; // UTF-8 BOM (한글 깨짐 방지)
        //             allExcepData.forEach(row => {
        //                 csvContent += `${row.qr_code},${row.auth_key}\n`;
        //             });
        //
        //             const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        //             const link = document.createElement("a");
        //             const url = URL.createObjectURL(blob);
        //             link.setAttribute("href", url);
        //             link.setAttribute("download", "QR_CODE_발행_" + new Date().getTime() + ".csv");
        //             link.style.visibility = 'hidden';
        //             document.body.appendChild(link);
        //             link.click();
        //             document.body.removeChild(link);
        //         }
        //
        //     } catch (error) {
        //         console.error(error);
        //         this.$message.error("데이터를 가져오는 중 오류가 발생했습니다.");
        //     } finally {
        //         this.loading = false;
        //     }
        // },

      getCheckSum(hex)
      {
        var chk = hex.length
        var value = 0;
        for(var i=0; i <hex.length; i += 2) {
          value +=  parseInt(hex.substring(i, i+2),16) * chk
          chk ++;
        }
        var res = value * 1224 % 100;
        if (res <= 9)
          return '0' + res;
        else
          return res;
      },

      convertToHex(str) {
          var hex = '';
          for(var i=0;i<str.length;i++) {
            hex += str.charCodeAt(i).toString(16);
          }
        return hex;
      },

      convertToString(hex) {

        //console.log("convertToString");
        //console.log(hex);

        var str = '';
        for(var i=0;i<hex.length; i += 2) {
          str += String.fromCharCode(parseInt(hex.substring(i, i+2),16))
        }
        return str;
      },

      filesChange(e) {
        let fileName = e.target.files[0].name
        let lastIndex = fileName.lastIndexOf('.')
        let fileExtension = fileName.substring(lastIndex, fileName.length).toLowerCase()

        if (fileExtension !== '.txt' ||  fileExtension !== '.csv') {
          // this.$alert('텍스트 파일만 업로드 가능합니다.', '알림', { confirmButtonText: '확인' })
          // return
        }

        let fileList = e.target.files
        if (!fileList.length) return

        const reader = new FileReader()
        const file = e.target.files[0];
        reader.onload =  evt => {
          this.text = evt.target.result;
          const textArray = this.text.split('\n');
          // console.log(textArray);

          //console.log("======================" + this.text.length );
          if (this.text.length < 10)
          {
            this.$message.error(" 파일 포맷 오류 입니다. ");
            this.$refs.form.reset() ;
            return ;
          }
          const reqJson=[];
          this.loading = true;
          for(var i in textArray){
            if (i==0)
              continue;
              const dataArray = textArray[i].trim().split(',');
                // comma 보다 작으면

            if (dataArray.length  < 2)
            {
              break;
            }

            //console.log ( 'number : ' + i  ) ;
             //console.log ( textArray[i].trim() ) ;
            //console.log ( dataArray[0].trim()) ;
            //console.log ( dataArray[1].trim()) ;

            //console.log ( "pppppppppppppppppppppppppppppppppppp" ) ;


              reqJson.push({
                qr_code :  dataArray[0].trim()
                , auth_key: dataArray[1].trim()
              });
          }

          //console.log(reqJson);
          let url = "";
          url = this.$url + '/rfidInfo/insert2';

          Axios.post(url, reqJson , this.$store.state.config  ).then(res => { 
          
            //console.log(res);
            let saveCount = res.data;
            this.loading = false;
            this.$message.success(saveCount +'건 ' + this.$store.state.saveSuccess);
            this.search();
            // this.$refs.myFiles.files[0].name = null;
          }).catch(error => {
            console.log(error.response)
            this.$message.error(this.$store.state.serverErrorMessage);
            this.currentPage = 1;
            this.loading = false;
          }); // await Axios.post

        }
         reader.readAsText(file)
              
      },//filesChange

      Confirm(){
        // this.e.target.files[0].name = "";

        this.$refs.form.reset() ;
        this.dialogVisible = false
      },

      submitUpload() {
        this.$refs.upload.submit();
      },



      async remove(){
        if (this.multipleSelection.length <= 0)
        {
          this.$message.error("데이터를 선택하세요 ");
          return ;
        }
        this.loading = true;
        let url = "";
        url = this.$url + '/rfidInfo/removeRfidOrderSeq';
        const config = {
          ...this.$store.state.config,
          headers: {
            ...this.$store.state.config.headers,
            Authorization: `Bearer ${this.$store.state.accessToken}`
          }
        };
        Axios.post(url, this.multipleSelection, config).then(res => {

          //console.log(res );
          let saveCount = res.data;
          this.loading = false;
          this.$message.success(saveCount +'건 삭제 되었습니다.');
          this.search(false);

        }).catch(error => {
          console.log(error.response)
          this.$message.error(this.$store.state.serverErrorMessage);
          this.currentPage = 1;
          this.loading = false;
        }); // await Axios.post
      }, // remove


    }, //methods
  }
</script>


<style>





</style>
